import { observable } from 'mobx';
import Client from '../../common/client';

const CusEntInfoStore = observable({
  cusEntInfo: null,
  lineNumberList: null,
  visibleLineNumberPopup: false,
  visibleCusEntInsertPopup: false,

  *getCusEntInfo() {
    try {
      const { EntCode: code } = JSON.parse(sessionStorage.getItem('user'));

      let response = yield Client.post('/Cems/CustomerEntertainment/CusEntInfo/', {
        entCode: code,
      });

      // console.log('CusEntInfoStore > *getCusEntInfo response : ', response);

      const cusEntInfo = response.data[0];

      // console.log('CusEntInfoStore > *getCusEntInfo cusEntInfo : ', cusEntInfo);

      if (cusEntInfo) {
        this.cusEntInfo = cusEntInfo;
      } else {
        this.cusEntInfo = [];
      }
    } catch (error) {
      console.log(`CusEntInfoStore > *getCusEntInfo : ${error.message}`);
    }
  },

  // 전화번호수정
  setVisibleLineNumberPopup(visible) {
    // console.log('setVisibleLineNumberPopup : ', visible);
    this.visibleLineNumberPopup = visible;
  },

  *getCusEntLineNumber() {
    try {
      const { EntCode: code } = JSON.parse(sessionStorage.getItem('user'));

      let response = yield Client.post('/Cems/CustomerEntertainment/LineNumberListSearch/', {
        companyCode: '1000000098',
        entCode: code,
      });

      // console.log('CusEntInfoStore > *getCusEntLineNumber response : ', response);

      const lineNumberList = response.data;

      // console.log('CusEntInfoStore > *getCusEntLineNumber lineNumberList : ', lineNumberList);

      if (lineNumberList) {
        this.lineNumberList = lineNumberList;
      } 
    } catch (error) {
      console.log(`CusEntInfoStore > *getCusEntLineNumber : ${error.message}`);
    }
  },

  *updateCusEntLineNumber(lineNumberList) {
    const { EntCode: code } = JSON.parse(sessionStorage.getItem('user'));

    if (!code || code === '') {
      return { error: true, message: '업소고객코드를 확인할 수 없습니다.' };
    }

    // console.log(code)
    // console.log(this.cusEntInfo.CustomerCode)
    // console.log(this.cusEntInfo.CompanyCode)
    // console.log(lineNumberList)

    try {
      const response = yield Client.post('/Cems/CustomerEntertainment/CusEntLineNumberUpdate/', {
        entCode: code,
        customerCode: this.cusEntInfo.CustomerCode,
        companyCode: this.cusEntInfo.CompanyCode,
        lineNumbers: lineNumberList,
      });

      // console.log('CusEntInfoStore > *updateCusEntLineNumber response : ', response);

      var result = response.data[0];

      if (result.ResultYN) {
        return { error: false, message: result.ResultMessage};
      } else {
        return { error: true, message: result.ResultMessage };
      }

      // return { error: true, message: 'test' };
    } catch (error) {

      return {
        error: true,
        message: `오류가 발생하였습니다.\n${error.message}`,
      };
    }
  },

  // 전화번호수정
  setVisibleCusEntInsertPopup(visible) {
    // console.log('setVisibleCusEntInsertPopup : ', visible);
    this.visibleCusEntInsertPopup = visible;
  },

  clear() {
    this.cusEntInfo = null;
  },
});

export default CusEntInfoStore;
